import React, { Suspense, lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';
import { CircularProgress, Box } from "@mui/material";
import Navigation from "../customer/Components/Navbar/Navigation";
import Footer from "../customer/Components/footer/Footer";
import { customerTheme } from "../Theme/customeTheme";

// Lazy load all route components
const Homepage = lazy(() => import("../Pages/Homepage"));
const ProductDetails = lazy(() => import("../customer/Components/Product/ProductDetails/ProductDetails"));
const Product = lazy(() => import("../customer/Components/Product/Product/Product"));
const Contact = lazy(() => import("../Pages/Contact"));
const TearmsCondition = lazy(() => import("../Pages/TearmsCondition"));
const PrivacyPolicy = lazy(() => import("../Pages/PrivacyPolicy"));
const Cart = lazy(() => import("../customer/Components/Cart/Cart"));
const Order = lazy(() => import("../customer/Components/orders/Order"));
const OrderDetails = lazy(() => import("../customer/Components/orders/OrderDetails"));
const Checkout = lazy(() => import("../customer/Components/Checkout/Checkout"));
const PaymentSuccess = lazy(() => import("../customer/Components/paymentSuccess/PaymentSuccess"));
const RateProduct = lazy(() => import("../customer/Components/ReviewProduct/RateProduct"));
const About = lazy(() => import("../Pages/About"));
const NotFound = lazy(() => import("../Pages/Notfound"));
const GuestOrderTracking = lazy(() => import("../customer/Components/GuestOrderTracking/GuestOrderTracking"));
const Profile = lazy(() => import("../customer/Components/Profile/Profile"));

// Loading component
const PageLoader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <CircularProgress size={50} />
    <p className="text-gray-600 dark:text-gray-400 text-sm">Loading...</p>
  </Box>
);

// Page transition wrapper
const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3, ease: 'easeInOut' }}
  >
    {children}
  </motion.div>
);

const CustomerRoutes = () => {
  const location = useLocation();
  const showNavigation = location.pathname !== "*";
  return (
    <div>
      <ThemeProvider theme={customerTheme}>
        {showNavigation && <Navigation />}
        <Suspense fallback={<PageLoader />}>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/login" element={<PageTransition><Homepage /></PageTransition>} />
              <Route path="/register" element={<PageTransition><Homepage /></PageTransition>} />
              <Route path="/" element={<PageTransition><Homepage /></PageTransition>} />
              <Route path="/home" element={<PageTransition><Homepage /></PageTransition>} />
              <Route path="/privaciy-policy" element={<PageTransition><PrivacyPolicy /></PageTransition>} />
              <Route path="/terms-condition" element={<PageTransition><TearmsCondition /></PageTransition>} />
              <Route path="/contact-us" element={<PageTransition><Contact /></PageTransition>} />
              <Route path="/:lavelOne/:lavelTwo" element={<PageTransition><Product /></PageTransition>} />
              <Route path="/:lavelOne/:lavelTwo/:lavelThree" element={<PageTransition><Product /></PageTransition>} />
              <Route path="/product/:productId" element={<PageTransition><ProductDetails /></PageTransition>} />
              <Route path="/cart" element={<PageTransition><Cart /></PageTransition>} />
              <Route path="/account/profile" element={<PageTransition><Profile /></PageTransition>} />
              <Route path="/account/order" element={<PageTransition><Order /></PageTransition>} />
              <Route path="/account/order/:orderId" element={<PageTransition><OrderDetails /></PageTransition>} />
              <Route path="/account/rate/:productId" element={<PageTransition><RateProduct /></PageTransition>} />
              <Route path="/checkout" element={<PageTransition><Checkout /></PageTransition>} />
              <Route path="/payment/:orderId" element={<PageTransition><PaymentSuccess /></PageTransition>} />
              <Route path="/about-us" element={<PageTransition><About /></PageTransition>} />
              <Route path="/track-order" element={<PageTransition><GuestOrderTracking /></PageTransition>} />
              <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
            </Routes>
          </AnimatePresence>
        </Suspense>
        <Footer />
      </ThemeProvider>
    </div>
  );
};

export default CustomerRoutes;
